import { render } from "./ScaleLoader.vue?vue&type=template&id=0597a7c1"
import script from "./ScaleLoader.vue?vue&type=script&lang=js"
export * from "./ScaleLoader.vue?vue&type=script&lang=js"

import "./ScaleLoader.vue?vue&type=style&index=0&id=0597a7c1&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__